import { TabPanel, TabPanelProps } from "@mui/lab";
import { styled } from "@mui/material";

interface CustomTabPanelProps extends TabPanelProps {
  noPadding?: boolean;
}

const StyledTabPanel = styled(({ noPadding, ...props }: CustomTabPanelProps) => (
  <TabPanel {...props} />
))<CustomTabPanelProps>(({ noPadding }) => ({
  paddingTop: "16px",
  paddingBottom: noPadding ? "0 !important" : "16px !important",
  paddingLeft: noPadding ? "0 !important" : "16px !important",
  paddingRight: noPadding ? "0 !important" : "16px !important",
}));

export function TabPanelStyled(props: CustomTabPanelProps) {
  const { noPadding, ...otherProps } = props;
  return <StyledTabPanel noPadding={noPadding} {...otherProps} />;
}



